import {loadImage, loadScriptOnce} from './utils';

document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll("[data-lazyload]");

  if (!images.length) return;

  const callback = function (entries, observer) {

    Array.prototype.forEach.call(entries, function (entry) {
      if (entry.intersectionRatio > 0) {
        observer.unobserve(entry.target);
        loadImage(entry.target);
      }
    });
  };

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(images, function (element) {
      loadImage(element);
    });
    loadScriptOnce('/local/templates/template3/public/js/vendor/ofi.min.js', function () {
      objectFitImages();
    });

  } else {

    const config = {
      rootMargin: '300px 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver(callback, config);

    Array.prototype.forEach.call(images, function (element) {
      observer.observe(element);
    });
  }
});
